'use client';

import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionPointerProps extends PropsWithChildren {
  mouse?: string;
  touch?: string;
  mouseAndTouch?: string;
}

export const ConditionPointer: FC<ConditionPointerProps> = ({
  mouse,
  touch,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { touchPosition, mousePosition } = dataBlocks;
  const { DataPopup } = useDataPopup();

  const [handle, setHandle] = useState<React.ReactNode>(children);

  useEffect(() => {
    if (touchPosition?.value) {
      setHandle(touch);
    } else if (mousePosition?.value) {
      setHandle(mouse);
    } else {
      setHandle(children);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- branch props are static JSX; keyed on the detected value
  }, [touchPosition?.value, mousePosition?.value]);

  return (
    <DataPopup
      handle={handle}
      subheading={messages['condition.pointer.description']}
      condition={{
        title: messages['condition.pointer'],
        options: [
          {
            title: messages['condition.pointer.mouse'],
            value: mouse,
          },
          {
            title: messages['condition.pointer.touch'],
            value: touch,
          },
          {
            title: messages['condition.pointer.unknown'],
            value: children?.toString() || '',
          },
        ],
      }}
      dataBlocks={{ touchPosition, mousePosition }}
    />
  );
};
